import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturou:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-6" data-testid="error-boundary-screen">
          <div className="max-w-lg w-full bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6 border border-red-200 dark:border-red-800">
            <h1 className="text-lg font-bold text-red-600 mb-2">Ops, algo deu errado nesta tela</h1>
            <p className="text-sm text-slate-600 dark:text-slate-300 mb-3">
              O erro foi registrado. Tente recarregar a página — se persistir, envie a mensagem abaixo para o suporte:
            </p>
            <pre className="text-xs bg-slate-100 dark:bg-slate-900 text-red-700 dark:text-red-400 p-3 rounded overflow-auto max-h-40 mb-4 whitespace-pre-wrap">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm font-medium"
              data-testid="error-reload-btn"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
